import React from "react"
import Carousel from "../Carousel/Carousel"
import { GatsbyImage } from "gatsby-plugin-image"
import * as styles from "./Testimonial.module.scss"
import { RichText } from "../RichText/RichText"

const Testimonial = ({
    testimonials,
    type,
    backgroundColor,
    testimonialImage,
    title,
    buttonTestimonial

}) => {

    const renderStandardTestimonial = testimonial => (
        <div className={styles.content}>
            <div className={styles.col1}>
                <div className={styles.stars}>
                    {[...Array(5)].map((_, index) => (
                        <span
                            key={index}
                            style={{
                                color: index < (testimonial.rating || 0) ? "#FFD700" : "#777586",
                            }}
                        >
                            &#9733;
                        </span>
                    ))}
                </div>
                <blockquote className={styles.text}>
                    {testimonial && <RichText content={testimonial.description} />}
                </blockquote>
            </div>

            <div className={styles.col2}>
                <p className={styles.name}>{testimonial.user}</p>
                <p className={styles.designation}>{testimonial.designation}</p>
                {testimonial.companyLogo && (
                    <GatsbyImage
                        image={testimonial.companyLogo.gatsbyImageData}
                        className={styles.companyLogo}
                        alt={testimonial.companyLogo.title || "Company logo"}
                    />
                )}
            </div>


        </div>
    )

    const renderFullWidthTestimonial = testimonial => (
        <div className={`${styles.mainCol}  ${styles.content2} `}>
            {[...Array(5)].map((_, index) => (
                <span
                    key={index}
                    style={{
                        color: index < (testimonial.rating || 0) ? "#FFD700" : "#777586",
                    }}
                >
                    &#9733;
                </span>
            ))}
            <div className={styles.paraSection}>
                {testimonial && <RichText content={testimonial.description} />}
            </div>

            <div className={styles.column}>
                <div>
                    <p className={styles.authorName}>{testimonial.name}</p>
                    <p className={styles.authorDesignation}>{testimonial.designation}</p>
                </div>
                <div>
                    {testimonial.companyLogo && (
                        <GatsbyImage
                            image={testimonial.companyLogo.gatsbyImageData}
                            className={styles.Logo}
                            alt={testimonial.companyLogo.title || "Company logo"}
                        />
                    )}
                </div>
            </div>
        </div>
    )

    const renderTestimonialsColumnWithImage = testimonial => (
        <div className={`${styles.mainCol}  ${styles.contentWithImage} `}>
            {[...Array(5)].map((_, index) => (
                <span
                    key={index}
                    style={{
                        color: index < (testimonial.rating || 0) ? "#FFD700" : "#777586",
                    }}
                >
                    &#9733;
                </span>
            ))}
            <div className={styles.paraSection}>
                {testimonial && <RichText content={testimonial.description} />}
            </div>
            <div className={styles.column}>
                <div>
                    <p className={styles.authorName}>{testimonial.name}</p>
                    <p className={styles.authorDesignation}>{testimonial.designation}</p>
                </div>
                <div>
                    {testimonial.companyLogo && (
                        <GatsbyImage
                            image={testimonial.companyLogo.gatsbyImageData}
                            className={styles.Logo}
                            alt={testimonial.companyLogo.title || "Company logo"}
                        />
                    )}
                </div>
            </div>
        </div>
    )

    if (type === "TestimonialsColumn") {
        return (
            <section style={{ backgroundColor }}>
                <div
                    className={` bg-white container c-padding ${styles.fullWidthContainer}`}
                >
                    {testimonials.map((testimonial, index) => (
                        <React.Fragment key={index}>
                            {renderFullWidthTestimonial(testimonial)}
                        </React.Fragment>
                    ))}
                </div>
            </section>
        )
    }

    if (type === "TestimonialsColumnWithImage") {
        return (
            <section style={{ backgroundColor }}>
                <div
                    className={` bg-white container c-padding ${styles.fullWidthContainerWithImage}`}
                >
                    <div className={styles.imageTestimonial}>
                        {testimonialImage && (
                            <GatsbyImage
                                image={testimonialImage.gatsbyImageData}
                                alt={testimonialImage.title || "Image"}
                            />
                        )}
                    </div>
                    {testimonials.map((testimonial, index) => (
                        <React.Fragment key={index}>
                            {renderTestimonialsColumnWithImage(testimonial)}
                        </React.Fragment>
                    ))}
                </div>
            </section>
        )
    }

    return (
        <section>
            <Carousel
                title={title}
                items={testimonials}
                renderItem={renderStandardTestimonial}
                settings={{ showDots: true, showArrows: true }}
                buttonTestimonial={buttonTestimonial}
            />
        </section>
    )
}

export default Testimonial
